import { useSettingEnableMakerSignUpHooksMigration } from "@faire/retailer/settings/useSettingEnableMakerSignUpHooksMigration";
import { MakerSignUpState } from "@faire/retailer/views/apply/MakerApplication/MakerSignUpState";

import { useMakerSignUpFormContextStore } from "../MakerSignUpFormStore";
import { useMakerSignUpContextStore } from "../MakerSignUpStore";
import { useMakerSignUp } from "../useMakerSignUp";
import { useMakerSignUpForm } from "../useMakerSignUpForm";

// eslint-disable-next-line complexity
export const useMakerSignUpFormFields = (viewState: MakerSignUpState) => {
  const enableMakerSignUpHooksMigration =
    useSettingEnableMakerSignUpHooksMigration();
  const [
    {
      companyName,
      url,
      email,
      categoryOption,
      stockists,
      numProducts,
      urlValidationInProgress,
      secondaryCategoryOptions,
    },
  ] = useMakerSignUpFormContextStore([
    "companyName",
    "url",
    "email",
    "categoryOption",
    "stockists",
    "numProducts",
    "urlValidationInProgress",
    "secondaryCategoryOptions",
  ]);
  const [{ acceptedTerms }] = useMakerSignUpContextStore(["acceptedTerms"]);
  const {
    countryLabel,
    onUrlBlur,
    errorFor,
    isUrlValid,
    onChange,
    onSubmit,
    brandNameEvent,
    setCountry,
    emailEvent,
    categoryEvent,
    setFormField,
    returnEvent,
    sourceEvent,
    countryEvent,
    selectedProductCategory,
    shouldCollectSecondaryProductCategory,
    numberStoresEvent,
  } = useMakerSignUpForm();
  const {
    countryDropdownOption,
    displaySource,
    onBackClick,
    toggleAcceptedTerms,
    shouldShowSMSOptIn,
  } = useMakerSignUp();

  return {
    companyName: enableMakerSignUpHooksMigration
      ? companyName
      : viewState.companyName,
    countryLabel: enableMakerSignUpHooksMigration
      ? countryLabel
      : viewState.countryLabel,
    countryDropdownOption: enableMakerSignUpHooksMigration
      ? countryDropdownOption
      : viewState.countryDropdownOption,
    setCountry: enableMakerSignUpHooksMigration
      ? setCountry
      : viewState.setCountry,
    url: enableMakerSignUpHooksMigration ? url : viewState.url,
    email: enableMakerSignUpHooksMigration ? email : viewState.email,
    categoryOption: enableMakerSignUpHooksMigration
      ? categoryOption
      : viewState.categoryOption,
    stockists: enableMakerSignUpHooksMigration
      ? stockists
      : viewState.stockists,
    numProducts: enableMakerSignUpHooksMigration
      ? numProducts
      : viewState.numProducts,
    displaySource: enableMakerSignUpHooksMigration
      ? displaySource
      : viewState.displaySource,
    onUrlBlur: enableMakerSignUpHooksMigration
      ? onUrlBlur
      : viewState.onUrlBlur,
    errorFor: enableMakerSignUpHooksMigration ? errorFor : viewState.errorFor,
    urlValidationInProgress: enableMakerSignUpHooksMigration
      ? urlValidationInProgress
      : viewState.urlValidationInProgress,
    isUrlValid: enableMakerSignUpHooksMigration
      ? isUrlValid
      : viewState.isUrlValid,
    onChange: enableMakerSignUpHooksMigration ? onChange : viewState.onChange,
    onSubmit: enableMakerSignUpHooksMigration
      ? onSubmit
      : viewState.onSubmit.bind(viewState),
    onBackClick: enableMakerSignUpHooksMigration
      ? onBackClick
      : viewState.onBackClick,
    brandNameEvent: enableMakerSignUpHooksMigration
      ? brandNameEvent
      : viewState.brandNameEvent,
    acceptedTerms: enableMakerSignUpHooksMigration
      ? acceptedTerms
      : viewState.acceptedTerms,
    toggleAcceptedTerms: enableMakerSignUpHooksMigration
      ? toggleAcceptedTerms
      : viewState.toggleAcceptedTerms,
    shouldShowSMSOptIn: enableMakerSignUpHooksMigration
      ? shouldShowSMSOptIn
      : viewState.shouldShowSMSOptIn,
    emailEvent: enableMakerSignUpHooksMigration
      ? emailEvent
      : viewState.emailEvent,
    categoryEvent: enableMakerSignUpHooksMigration
      ? categoryEvent
      : viewState.categoryEvent,
    setFormField: enableMakerSignUpHooksMigration
      ? setFormField
      : viewState.setFormField.bind(viewState),
    returnEvent: enableMakerSignUpHooksMigration
      ? returnEvent
      : viewState.returnEvent,
    sourceEvent: enableMakerSignUpHooksMigration
      ? sourceEvent
      : viewState.sourceEvent,
    countryEvent: enableMakerSignUpHooksMigration
      ? countryEvent
      : viewState.countryEvent,
    secondaryCategoryOptions: enableMakerSignUpHooksMigration
      ? secondaryCategoryOptions
      : viewState.secondaryCategoryOptions,
    selectedProductCategory: enableMakerSignUpHooksMigration
      ? selectedProductCategory
      : viewState.selectedProductCategory,
    shouldCollectSecondaryProductCategory: enableMakerSignUpHooksMigration
      ? shouldCollectSecondaryProductCategory
      : viewState.shouldCollectSecondaryProductCategory,
    numberStoresEvent: enableMakerSignUpHooksMigration
      ? numberStoresEvent
      : viewState.numberStoresEvent,
  };
};
